<div class="card">
    <h1>Slik går du frem for å laste ned en PDF-fil</h1>

    <p>
        Last ned en samlet PDF med resultatene fra kartleggingen.
        Rapporten gir oversikt over funn, utfordringer og aktuelle tiltak.
    </p>

    <hb-accordion [gap]="'sm'" [visKantlinje]="false">

        <hb-accordion-element>
            <span title>iPhone eller iPad</span>

            <div body>
                <ol class="guide-content">
                    <li>Trykk på <strong>Last ned PDF</strong></li>
                    <li>Velg <strong>Lagre til Filer</strong></li>
                    <li>Velg en mappe du enkelt finner igjen</li>
                </ol>
            </div>
        </hb-accordion-element>

        <hb-accordion-element>
            <span title>Android</span>

            <div body>
                <ol class="guide-content">
                    <li>Trykk på <strong>Last ned PDF</strong></li>
                    <li>Velg <strong>Lagre til Filer</strong></li>
                    <li>Velg en mappe du enkelt finner igjen</li>
                </ol>
            </div>
        </hb-accordion-element>

        <hb-accordion-element>
            <span title>Datamaskin</span>

            <div body>
                <ol class="guide-content">
                    <li>Trykk på <strong>Last ned PDF</strong></li>
                    <li>Velg <strong>Lagre til Filer</strong></li>
                    <li>Velg en mappe du enkelt finner igjen</li>
                </ol>
            </div>
        </hb-accordion-element>

    </hb-accordion>
</div>
